<div appDynamicScreenHeight>
    <mat-tab-group mat-stretch-tabs="false"
                   mat-align-tabs="start"
                   animationDuration="0"
                   class="lendio-secondary-tabs !px-4"
                   (selectedTabChange)="handleSelectedTabChange()">
        <mat-tab label="DSCR">
            <app-dscr-finances />
        </mat-tab>
        <mat-tab label="Business">
            <app-finance-view financeContext="business" />
        </mat-tab>
        <mat-tab label="Personal">
            <app-finance-view financeContext="personal" />
        </mat-tab>
    </mat-tab-group>
</div>
